export const GYM_MODULES = {
  invoice: 'invoice',
  trainerStaff: 'trainerStaffManagement',
  slotBooking: 'slotBooking',
  memberRetention: 'memberRetention',
};

export function getId(value) {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value._id || value.id || '';
}

export function getCurrentGym(user, gyms = []) {
  const gymId = getId(user?.gymId);
  if (!gymId) return null;
  return gyms.find(gym => getId(gym) === gymId) || null;
}

export function hasGymModule(gym, moduleKey) {
  if (!moduleKey) return true;
  const features = gym?.onboardingPricing?.features;
  if (!Array.isArray(features)) return false;
  return features.some(feature => feature.key === moduleKey && feature.selected === true);
}

export function userCanAccessGymModule(user, gyms, moduleKey) {
  if (!moduleKey) return true;
  if (user?.role === 'superadmin') return true;
  return hasGymModule(getCurrentGym(user, gyms), moduleKey);
}
